import { render, staticRenderFns } from "./HighlightCommentToggleParts.vue?vue&type=template&id=18981238&scoped=true"
import script from "./HighlightCommentToggleParts.vue?vue&type=script&lang=js"
export * from "./HighlightCommentToggleParts.vue?vue&type=script&lang=js"
import style0 from "./HighlightCommentToggleParts.vue?vue&type=style&index=0&id=18981238&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18981238",
  null
  
)

export default component.exports